import { render, staticRenderFns } from "./CoTwoLocationForm.vue?vue&type=template&id=3beb4bae&scoped=true&"
import script from "./CoTwoLocationForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoLocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3beb4bae",
  null
  
)

export default component.exports